import type {MobileMenuItem, NavTopLevelItem} from '@/types/navigation';

// @@@@@@@@@@@@@@@@@@@@@@@@@@@@@ menu links @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

const servicesGroups = [
    {
        heading: 'Software Development',
        categories: [
            {
                categoryHeading: 'Software Development',
                links: [
                    {label: 'Custom Software Development', path: '/custom-software-development-company'},
                    {label: 'Enterprise Software Development', path: '/enterprise-software-development'},
                    {label: 'SaaS Application Development', path: '/saas-development-company'},
                    {label: 'MVP Product Development', path: '/mvp-development-services'},
                    {label: 'Software Development Consulting', path: '/software-development-consulting-services'},
                    {label: 'IT Outsourcing Services', path: '/end-to-end-it-outsourcing-services'}
                ]
            },
            {
                categoryHeading: 'Web Development',
                links: [
                    {label: 'Web Development', path: '/web-development'},
                    {label: 'Full Stack Web Development', path: '/full-stack-web-development'},
                    {label: 'Progressive Web App Development', path: '/progressive-web-app-development'},
                    {label: 'Custom CMS Development', path: '/custom-cms-development-services'},
                    {label: 'API Development & Integration', path: '/api-development-services'}
                ]
            },
            {
                categoryHeading: 'Development Technologies',
                links: [
                    {label: 'Laravel Development', path: '/laravel-development'},
                    {label: 'PHP Development', path: '/php-web-development'},
                    {label: 'Node.js Development', path: '/node-js-development'},
                    {label: 'ReactJS Development', path: '/react-js-development'},
                    {label: 'Python Development', path: '/python-development'},
                    {label: 'Java Development', path: '/java-development'}
                ]
            }
        ]
    },
    {
        heading: 'Mobile App Development',
        categories: [
            {
                categoryHeading: 'Mobile App Solutions',
                links: [
                    {label: 'Mobile App Development', path: '/mobile-application-development-services'},
                    {label: 'iOS App Development', path: '/ios-app-development-services'},
                    {label: 'Android App Development', path: '/android-app-development'},
                    {label: 'Hybrid App Development', path: '/hybrid-app-development'},
                    {label: 'Cross-Platform App Development', path: '/cross-platform-app-development-services'},
                    {label: 'App Maintenance & Support', path: '/mobile-app-maintenance-services'}
                ]
            },
            {
                categoryHeading: 'Mobile Technologies',
                links: [
                    {label: 'React Native App Development', path: '/react-native-app-development'},
                    {label: 'Flutter App Development', path: '/flutter-app-development'},
                    {label: 'Kotlin App Development', path: '/kotlin-app-development'}
                ]
            }
        ]
    },
    {
        heading: 'AI Development',
        categories: [
            {
                categoryHeading: 'AI & Machine Learning',
                links: [
                    {label: 'AI Development', path: '/ai-development-company'},
                    {label: 'Machine Learning Development', path: '/machine-learning-development-company'},
                    {label: 'Deep Learning Development', path: '/deep-learning-development'},
                    {label: 'Adaptive AI Development', path: '/adaptive-ai-development'},
                    {label: 'Data Engineering Services', path: '/data-engineering-services'},
                    {label: 'AI Deployment Services', path: '/ai-deployment-services'}
                ]
            },
            {
                categoryHeading: 'Generative AI & LLMs',
                links: [
                    {label: 'Generative AI Development', path: '/generative-ai-development-company'},
                    {label: 'Generative AI Integration', path: '/generative-ai-integration-services'},
                    {label: 'LLM Development', path: '/large-language-model-development'},
                    {label: 'LLM Fine-Tuning', path: '/llm-fine-tuning-services'},
                    {label: 'AI Prompt Engineering', path: '/ai-prompt-engineering-company'},
                    {label: 'AI Copilot Development', path: '/ai-copilot-development'}
                ]
            },
            {
                categoryHeading: 'AI Agents & Conversational Systems',
                links: [
                    {label: 'AI Agent Development', path: '/ai-agent-development-company'},
                    {label: 'AI Chatbot Development', path: '/ai-chatbot-development-company'},
                    {label: 'ChatGPT App Development', path: '/chatgpt-development-services'},
                    {label: 'ChatGPT Integration', path: '/chatgpt-integration-services'},
                    {label: 'NLP Development', path: '/natural-language-processing-development'}
                ]
            },
            {
                categoryHeading: 'AI Consulting & MLOps',
                links: [
                    {label: 'AI Consulting', path: '/ai-consulting-company'},
                    {label: 'Generative AI Consulting', path: '/generative-ai-consulting-company'},
                    {label: 'MLOps Consulting', path: '/mlops-consulting-services'},
                    {label: 'AI as a Service', path: '/ai-as-a-service'}
                ]
            }
        ]
    },
    {
        heading: 'Blockchain & Tokenization Development',
        categories: [
            {
                categoryHeading: 'Blockchain & Web3',
                links: [
                    {label: 'Blockchain Development', path: '/blockchain-development-services'},
                    {label: 'Web3 Development', path: '/web3-development-company'},
                    {label: 'dApp Development', path: '/dapp-development'},
                    {label: 'Blockchain Consulting', path: '/blockchain-consulting-services'},
                    {label: 'Smart Contract Audit', path: '/smart-contract-audit-services'},
                    {label: 'DAO Development', path: '/dao-development-company'},
                    {label: 'Smart Contract Development', path: '/smart-contract-development'},
                    {label: 'Blockchain Game Development', path: '/blockchain-game-development'},
                    {label: 'Blockchain AI Development', path: '/blockchain-ai-development'}
                ]
            },
            {
                categoryHeading: 'Blockchain Platforms',
                links: [
                    {label: 'Public Blockchain', path: '/public-blockchain-development'},
                    {label: 'Private Blockchain', path: '/private-blockchain-development'},
                    {label: 'Ethereum Development', path: '/ethereum-development-services'},
                    {label: 'Polygon Development', path: '/polygon-blockchain-development'},
                    {label: 'Solana Development', path: '/solana-blockchain-development'},
                    {label: 'Hyperledger Development', path: '/hyperledger-blockchain-development'},
                    {label: 'Cosmos Development', path: '/cosmos-blockchain-development'},
                    {label: 'Polkadot Development', path: '/polkadot-blockchain-development'},
                    {label: 'Cardano Development', path: '/cardano-blockchain-development-company'}
                ]
            },
            {
                categoryHeading: 'DeFi Development',
                links: [
                    {label: 'DeFi Development', path: '/decentralized-finance-defi-development'},
                    {label: 'DeFi Lending Platform Development', path: '/defi-lending-platform-development'},
                    {label: 'DeFi Staking Platform Development', path: '/defi-staking-platform-development'}
                ]
            },
            {
                categoryHeading: 'NFT Development',
                links: [
                    {label: 'NFT Marketplace Development', path: '/nft-marketplace-development'},
                    {label: 'NFT Art Marketplace Development', path: '/nft-art-marketplace'},
                    {label: 'NFT Fashion Marketplace Development', path: '/nft-fashion-marketplace'},
                    {label: 'NFT Music Marketplace Development', path: '/music-nft-marketplace'}
                ]
            },
            {
                categoryHeading: 'Asset & Fund Tokenization',
                links: [
                    {label: 'Real-World Asset Tokenization', path: '/real-world-asset-tokenization'},
                    {label: 'Real Estate Tokenization', path: '/real-estate-tokenization'},
                    {label: 'Fund Tokenization', path: '/fund-tokenization-development-services'},
                    {label: 'Legal & Compliance Advisory', path: '/real-estate-tokenization-legal-consulting'}
                ]
            }
        ]
    },
    {
        heading: 'Crypto Exchange & Wallet Development',
        categories: [
            {
                categoryHeading: 'Wallet Solutions',
                links: [
                    {label: 'Crypto Wallet', path: '/crypto-wallet'},
                    {label: 'Web3 Wallet', path: '/web3-wallet-development-company'},
                    {label: 'DeFi Wallet', path: '/defi-wallet-development-company'},
                    {label: 'Decentralized Wallet', path: '/decentralized-crypto-wallet-development'},
                    {label: 'Centralized Wallet', path: '/centralized-crypto-wallet-development'},
                    {label: 'MPC Crypto Wallet', path: '/mpc-crypto-wallet'},
                    {label: 'Multicurrency Wallet', path: '/multicurrency-wallet-development'},
                    {label: 'NFT Wallet', path: '/nft-wallet-development'},
                    {label: 'Bitcoin Wallet', path: '/bitcoin-wallet-development'},
                    {label: 'TRON Wallet', path: '/tron-wallet-development'},
                    {label: 'eWallet', path: '/eWallet-app-development'}
                ]
            },
            {
                categoryHeading: 'Exchange Platforms',
                links: [
                    {label: 'Cryptocurrency Exchange', path: '/cryptocurrency-exchange-development'},
                    {label: 'Centralized Exchange', path: '/centralized-crypto-exchange-development'},
                    {label: 'Decentralized Exchange', path: '/decentralized-crypto-exchange-development'},
                    {label: 'Hybrid Crypto Exchange', path: '/hybrid-crypto-exchange-development'},
                    {label: 'P2P Crypto Exchange', path: '/p2p-crypto-exchange-development'},
                    {label: 'Crypto Derivatives Exchange', path: '/crypto-derivatives-exchange-development'},
                    {label: 'Margin Trading Exchange', path: '/crypto-margin-trading-exchange-development'},
                    {label: 'OTC Crypto Exchange', path: '/otc-crypto-exchange-development'}
                ]
            },
            {
                categoryHeading: 'Token Development',
                links: [
                    {label: 'Crypto Token Development', path: '/token-development-company'},
                    {label: 'ERC-20 Token Development', path: '/erc20-token-development-company'},
                    {label: 'BEP-20 Token Development', path: '/bep20-token-development'},
                    {label: 'AI Token Development', path: '/ai-token-development'},
                    {label: 'Meme Coin Development', path: '/meme-coin-development'},
                    {label: 'Stablecoin Development', path: '/stablecoin-development-company'}
                ]
            },
            {
                categoryHeading: 'Token Launch Platforms',
                links: [
                    {label: 'ICO Development', path: '/ico-development-company'},
                    {label: 'IDO Development', path: '/ido-development-services'},
                    {label: 'IEO Development', path: '/ieo-development-company'},
                    {label: 'STO Development', path: '/security-token-offerings-sto-development-company'},
                    {label: 'ETO Development', path: '/equity-token-offering-eto-development'},
                    {label: 'Crypto Launchpad Development', path: '/crypto-launchpad-development'}
                ]
            },
            {
                categoryHeading: 'Trading & Liquidity Solutions',
                links: [
                    {label: 'Crypto Trading Bot Development', path: '/crypto-trading-bot-development'},
                    {label: 'Crypto Market-Making Solutions', path: '/crypto-market-making-services'},
                    {label: 'DEX Aggregator Development', path: '/dex-aggregator-development'}
                ]
            },
            {
                categoryHeading: 'Crypto Payment Solutions',
                links: [{label: 'Crypto Payment Gateway Development', path: '/crypto-payment-gateway-development'}]
            }
        ]
    },
    {
        heading: 'Hire Developers',
        categories: [
            {
                categoryHeading: 'Software Developers',
                links: [
                    {label: 'Hire Web Developers', path: '/hire-web-developers'},
                    {label: 'Hire Full Stack Developers', path: '/hire-full-stack-developers'},
                    {label: 'Hire SaaS Developers', path: '/hire-saas-developers'},
                    {label: 'Hire .NET Developers', path: '/hire-dot-net-developer'},
                    {label: 'Hire Laravel Developers', path: '/hire-laravel-developers'},
                    {label: 'Hire ReactJS Developers', path: '/hire-reactjs-developers'},
                    {label: 'Hire Node.js Developers', path: '/hire-dedicated-nodejs-developers'}
                ]
            },
            {
                categoryHeading: 'AI & ML Developers',
                links: [
                    {label: 'Hire AI Developers', path: '/hire-ai-developers'},
                    {label: 'Hire ChatGPT Developers', path: '/chatgpt-application-developers'},
                    {label: 'Hire Generative AI Developers', path: '/hire-generative-ai-developers'},
                    {label: 'Hire AI Agent Developers', path: '/hire-ai-agent-developers'},
                    {label: 'Hire Prompt Engineers', path: '/hire-prompt-engineers'},
                    {label: 'Hire Machine Learning Developers', path: '/hire-machine-learning-developers'}
                ]
            },
            {
                categoryHeading: 'Mobile App Developers',
                links: [
                    {label: 'Hire Mobile Developers', path: '/hire-mobile-app-developers'},
                    {label: 'Hire iOS Developers', path: '/hire-ios-developers'},
                    {label: 'Hire Android Developers', path: '/hire-android-app-developers'},
                    {label: 'Hire React Native Developers', path: '/hire-react-native-developers'},
                    {label: 'Hire Flutter Developers', path: '/hire-flutter-developers'},
                    {label: 'Hire Wearable App Developers', path: '/hire-wearable-app-developers'}
                ]
            },
            {
                categoryHeading: 'Blockchain & Web3 Developers',
                links: [
                    {label: 'Hire Blockchain Developers', path: '/hire-blockchain-developers'},
                    {label: 'Hire Smart Contract Developers', path: '/hire-smart-contract-developers'},
                    {label: 'Hire DeFi Developers', path: '/hire-defi-developers'},
                    {label: 'Hire NFT Developers', path: '/hire-nft-developers'}
                ]
            },
            {
                categoryHeading: 'Dedicated Development Teams',
                links: [
                    {label: 'Hire Remote Developers', path: '/hire-remote-developers'},
                    {label: 'Hire Dedicated Development Team', path: '/hire-development-team'}
                ]
            }
        ]
    },
    {
        heading: 'Software Testing, QA & DevOps',
        categories: [
            {
                categoryHeading: 'Quality Assurance & Testing',
                links: [
                    {label: 'Software Testing & QA', path: '/software-testing-services'},
                    {label: 'Manual Testing', path: '/manual-testing'},
                    {label: 'Automation Testing', path: '/automation-testing-services'}
                ]
            },
            {
                categoryHeading: 'DevOps & Delivery Engineering',
                links: [{label: 'DevOps Services', path: '/devops'}]
            }
        ]
    }
];

const servicesDesktopMenus = servicesGroups.map((group, groupIndex) => ({
    menuItems: {
        heading: group.heading,
        header: group.heading,
        path: '',
        number: groupIndex,
        target: '',
        customClassName: 'first-outer-link-wrapper',
        categories: group.categories.map((category) => ({
            categoryHeading: category.categoryHeading,
            links: category.links.map((link) => ({target: '', path: link.path, label: link.label, number: groupIndex}))
        }))
    }
}));

const servicesMobileChildren = servicesGroups.map((group) => ({
    heading: group.heading,
    path: null,
    Children: group.categories.map((category) => ({
        heading: category.categoryHeading,
        path: null,
        Children: category.links.map((link) => ({heading: link.label, path: link.path}))
    }))
}));

export const dummyMenuData: NavTopLevelItem[] = [
    {
        btnLabel: 'Services',
        path: null,
        multiSubChild: true,
        menus: servicesDesktopMenus
    },
    {
        btnLabel: 'Products',
        path: null,
        target: '',
        multiSubChild: false,
        menus: [
            {
                menuItems: {
                    heading: 'White Label Crypto Exchange',
                    header: 'Products',
                    path: '/white-label-crypto-exchange-development',
                    target: '',
                    customClassName: '',
                    submenu: [],
                    multiple: true
                }
            },

            {
                menuItems: {
                    heading: 'White Label Real Estate Tokenization Platform',
                    header: 'Products',
                    path: '/white-label-tokenization-platform-development',
                    target: '',
                    customClassName: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'White Label Crypto Wallet',
                    header: 'Products',
                    path: '/white-label-crypto-wallet',
                    target: '',
                    customClassName: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'White label NFT marketplace',
                    header: 'Products',
                    path: '/white-label-nft-marketplace',
                    target: '',
                    customClassName: '',
                    submenu: [],
                    multiple: true
                }
            }
        ]
    },
    {
        btnLabel: 'Industries',
        path: null,
        target: '',
        multiSubChild: false,
        menus: [
            {
                menuItems: {
                    header: 'Industries',
                    heading: 'Healthcare',
                    path: '/healthcare-app-development-company',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'Healthcare Software Development',
                    path: '/healthcare-software-development-services',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'Wearable App Development',
                    path: '/wearable-app-development',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    path: '/fintech-software-development',
                    target: '',
                    heading: 'Fintech',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    path: '/transport-logistics-software-development',
                    target: '',
                    heading: 'Transport & Logistics',
                    submenu: [],
                    multiple: true
                }
            },

            {
                menuItems: {
                    heading: 'EdTech',
                    path: '/education-app-development-company',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'On Demand App',
                    path: '/on-demand-app-development',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'Media & Entertainment',
                    path: '/media-entertainment-software-development',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'Real Estate',
                    path: '/real-estate-software-development',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'Legal Software Development',
                    path: '/legal-software-development-company',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            }
        ]
    },
    {
        btnLabel: 'Portfolio',
        path: '/portfolio',
        target: ''
    },
    {
        btnLabel: 'Resources',
        path: null,
        target: '',
        multiSubChild: false,
        menus: [
            {
                menuItems: {
                    path: '/use-cases',
                    target: '',
                    heading: 'Use Cases',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'Blog',
                    path: '/blog',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    heading: 'News',
                    path: '/news',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            }
        ]
    },
    {
        btnLabel: 'Company',
        path: null,
        target: '',
        multiSubChild: false,
        menus: [
            {
                menuItems: {
                    // header: 'Company',
                    heading: 'About Us',
                    path: '/about-us',
                    target: '',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    path: '/career',
                    target: '',
                    heading: 'Career',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    path: '/pricing-models',
                    target: '',
                    heading: 'Pricing Models',
                    submenu: [],
                    multiple: true
                }
            },
            {
                menuItems: {
                    path: '/faqs',
                    target: '',
                    heading: 'FAQs',
                    submenu: [],
                    multiple: true
                }
            }
        ]
    }
];

export const MobileMenuData: MobileMenuItem[] = [
    {
        heading: 'Services',
        path: null,
        Children: servicesMobileChildren
    },
    {
        heading: 'Products',
        path: null,
        Children: [
            {
                heading: 'White Label Crypto Exchange',
                path: '/white-label-crypto-exchange-development'
            },
            {
                heading: 'White Label Real Estate Tokenization Platform',
                path: '/white-label-tokenization-platform-development'
            },
            {
                heading: 'White Label Crypto Wallet',
                path: '/white-label-crypto-wallet'
            },
            {
                heading: 'White label NFT marketplace',
                path: '/white-label-nft-marketplace'
            }
        ]
    },
    {
        heading: 'Industries',
        Children: [
            {
                heading: 'Healthcare',
                path: '/healthcare-app-development-company'
            },
            {
                heading: 'Healthcare Software Development',
                path: '/healthcare-software-development-services'
            },
            {
                heading: 'Wearable App Development',
                path: '/wearable-app-development'
            },
            {
                path: '/fintech-software-development',
                heading: 'Fintech'
            },
            {
                path: '/transport-logistics-software-development',
                heading: 'Transport & Logistics'
            },
            {
                heading: 'EdTech',
                path: '/education-app-development-company'
            },
            {
                heading: 'On Demand App',
                path: '/on-demand-app-development'
            },
            {
                heading: 'Media & Entertainment',
                path: '/media-entertainment-software-development'
            },
            {
                heading: 'Real Estate',
                path: '/real-estate-software-development'
            },
            {
                heading: 'Legal Software Development',
                path: '/legal-software-development-company'
            }
        ]
    },
    {
        heading: 'Portfolio',
        path: '/portfolio'
    },
    {
        heading: 'Resources',
        path: null,
        Children: [
            {
                path: '/use-cases',
                heading: 'Use Cases'
            },
            {
                heading: 'News',
                path: '/news'
            },
            {
                heading: 'Blog',
                path: '/blog'
            }
        ]
    },
    {
        heading: 'Company',
        path: null,
        Children: [
            {
                heading: 'About Us',
                path: '/about-us'
            },
            {
                path: '/career',
                heading: 'Career'
            },
            {
                path: '/pricing-models',
                heading: 'Pricing Models'
            },
            {
                path: '/faqs',
                heading: 'FAQs'
            }
        ]
    }
];
